/**
 * Kundenportal für Großunternehmen - Ummeldungs-API
 *
 * Contact: we.it.ikp-team@wienenergie.at
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BeteiligtePartei } from './beteiligte-partei.model';


export interface Kunde { 
    vertragspartner?: BeteiligtePartei;
    rechnungsempfaenger?: BeteiligtePartei;
    hasZustimmung?: boolean;
    kundeTyp?: Kunde.KundeTypEnum;
    unterschrift?: string;
    email?: string;
    telefon?: string;
}
export namespace Kunde {
    export const KundeTypEnum = {
        VERWALTETER_KUNDE: 'VERWALTETER_KUNDE',
        ACCOUNT_KUNDE: 'ACCOUNT_KUNDE',
        EXTERNER_KUNDE: 'EXTERNER_KUNDE',
        UNBEKANNT: 'UNBEKANNT'
    } as const;
    export type KundeTypEnum = typeof KundeTypEnum[keyof typeof KundeTypEnum];
}


